import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Tampilkan loading spinner saat memeriksa status autentikasi
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    // Jika tidak login, redirect ke halaman login admin
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Jika sudah login, tampilkan children
  return children;
};

export default AdminProtectedRoute;